module.exports = __webpack_public_path__ + "img/Gallery_1_21.3c012eef.jpeg";